




















import { defineComponent, getCurrentInstance, ref, set } from "@vue/composition-api";
import emitter from "@/lib/emitter";
import { EVENTS } from "@/const";
import BaseButton from "@/components/BaseButton";
import BasePage from "@/components/BasePage";
import BaseSpinner from "@/components/BaseSpinner";
import PageTitle from "@/components/PageTitle";
import PayoutForm from "@/views/PagePayeeInfo/components/PayoutForm.vue";
import PersonalInfoForm from "@/views/PagePayeeInfo/components/PersonalInfoForm.vue";

export default defineComponent({
  name: "PayeeInfoEditView",
  components: {
    BasePage,
    PageTitle,
    BaseSpinner,
    BaseButton,
    PersonalInfoForm,
    PayoutForm,
  },
  setup() {
    const loading = ref(false);
    const valid = ref(true);
    const submits: Record<string, () => Promise<any>> = {};
    const vm = getCurrentInstance();

    const setCb = (stepName: string, cb: Promise<any>) => {
      set(submits, stepName, cb);
    };
    const onSubmit = async () => {
      try {
        loading.value = true;
        for (let key in submits) {
          await submits[key]?.();
        }
        vm?.$router.push({ name: "profilePayeeInfo" });
        emitter.emit(EVENTS.NOTIFICATION_SHOW, { text: "Changes have been saved" });
      } catch (e) {
        console.error(e);
        return;
      } finally {
        loading.value = false;
      }
    };

    return {
      loading,
      valid,
      setCb,
      onSubmit,
    };
  },
});
